import { Typography } from '@mui/material'

export const FailedToRetrieveData = () => (
  <Typography variant="h5">
    Failed to fetch data, try again! <br />
    If this error continues to pop up, contact support!{' '}
  </Typography>
)
